__turbopack_context__.v({
  "backLink": "richText-module___9gOPq__backLink",
  "citation": "richText-module___9gOPq__citation",
  "figure": "richText-module___9gOPq__figure",
  "imageButton": "richText-module___9gOPq__imageButton",
  "imageFull": "richText-module___9gOPq__imageFull",
  "imageModal": "richText-module___9gOPq__imageModal",
  "modal": "richText-module___9gOPq__modal",
  "modalClose": "richText-module___9gOPq__modalClose",
  "modalHeader": "richText-module___9gOPq__modalHeader",
  "modalTraceHost": "richText-module___9gOPq__modalTraceHost",
  "referenceUrl": "richText-module___9gOPq__referenceUrl",
  "references": "richText-module___9gOPq__references",
  "richText": "richText-module___9gOPq__richText",
  "table": "richText-module___9gOPq__table",
  "tableWrap": "richText-module___9gOPq__tableWrap",
  "trace": "richText-module___9gOPq__trace",
  "traceEnlarge": "richText-module___9gOPq__traceEnlarge",
  "traceFrame": "richText-module___9gOPq__traceFrame",
  "traceFullWidth": "richText-module___9gOPq__traceFullWidth",
  "traceHost": "richText-module___9gOPq__traceHost",
  "traceMissing": "richText-module___9gOPq__traceMissing",
  "traceStatus": "richText-module___9gOPq__traceStatus",
  "traceThumbnail": "richText-module___9gOPq__traceThumbnail",
});
